export type { SurfaceProps, SurfaceVariant } from '../../types/surface';
export { Surface } from './adapters/inbound/Surface';
